import { render, staticRenderFns } from "./ViewPaper.vue?vue&type=template&id=17e40254&scoped=true"
import script from "./ViewPaper.vue?vue&type=script&lang=js"
export * from "./ViewPaper.vue?vue&type=script&lang=js"
import style0 from "./ViewPaper.vue?vue&type=style&index=0&id=17e40254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e40254",
  null
  
)

export default component.exports